<template lang="pug">
    .card
      .card-content
        div(v-if="tagline") {{ tagline }}
        div(v-if="gender")
          .icon
            i.fas(v-bind:class="gender.iconClass")
          span {{ gender.label }}
        div {{ insurance }}
        .has-text-weight-semibold Specialisms
        div(v-for="specialism in specialisms") {{ specialism }}
        div.has-text-weight-semibold Price packages
        div(v-for="price in prices") {{ price }}
        div(v-if="bioAndApproach")
          div.has-text-weight-semibold Bio and approach
          div {{ bioAndApproach }}
        div.has-text-weight-semibold Qualifications
        div(v-for="qualification in qualifications") {{ qualification }}
        div.has-text-weight-semibold Memberships
        div(v-for="membership in memberships") {{ membership }}
        div.has-text-weight-semibold Where I train
        div {{ locationAddress }}
        div.has-text-weight-semibold Location description
        div {{ locationDescription }}
</template>

<script>
import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  mixins: [
    ApiMixin
  ],
  props: {
    locations: {
      required: true,
      type: Array
    },
    professional: {
      required: true,
      type: Object
    }
  },
  computed: {
    bioAndApproach () {
      return this.professional.description ? decodeURIComponent(this.professional.description) : null
    },
    gender () {
      switch (this.professional.gender) {
        case 'F':
          return {
            iconClass: 'fa-venus',
            label: 'Female'
          }
        case 'M':
          return {
            iconClass: 'fa-mars',
            label: 'Male'
          }
        default:
          return null
      }
    },
    insurance () {
      return this.professional.insurance === 1 ? 'Fully insured and certified' : 'Not fully insured & certified'
    },
    location () {
      return this.locations.find((location) => location.id === this.professional.locations[0].id)
    },
    locationAddress () {
      return this.location ? this.location.address : null
    },
    locationDescription () {
      return this.professional.location_description ? decodeURIComponent(this.professional.location_description) : null
    },
    memberships () {
      return this.professional.memberships.map((membership) => this.apiAccreditations.find((apiAccreditation) => apiAccreditation.id === membership).description).sort()
    },
    prices () {
      return [
        `Price for 1 session: £${this.professional.prices[0].General.price1}`,
        `Price for 5 sessions: £${this.professional.prices[0].General.price5}`,
        `Price for 10 sessions: £${this.professional.prices[0].General.price10}`
      ]
    },
    qualifications () {
      return this.professional.qualifications.map((qualification) => this.apiAccreditations.find((apiAccreditation) => apiAccreditation.id === qualification).description).sort()
    },
    specialisms () {
      return this.professional.services.map((service) => this.apiServices.find((apiService) => apiService.id === service).description).sort()
    },
    tagline () {
      return this.professional.tagline ? decodeURIComponent(this.professional.tagline) : null
    }
  }
}
</script>
